<template>
  <b-card
    no-body
  >
    <div>
      <div
        class="m-2"
      >
        <!-- input -->
        <b-row>
          <b-col
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <div>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                size="md"
                class="d-flex align-items-center custom-button-color"
                @click="addNewSession()"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-50"
                />
                <span class="align-middle refresh-span">New Sorting</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- table -->
      <b-overlay
        id="overlay-background"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <b-table
          :per-page="perPage"
          :fields="fields"
          :items="rows"
          hover
          responsive
          striped
          show-empty
          @sort-changed="sortChanged"
        >
          <template #empty>
            <TableDataFetching
              :rows="rows"
              :data-loading="dataLoading"
            />
          </template>
          <template #head()="{ field }">
            <div
              class="sortable-header"
            >
              <span class="header-text">{{ field.label }}</span>
              <feather-icon
                v-if="field.sortable"
                :icon="sort === field.key
                  ? 'ArrowUpIcon'
                  : 'ArrowDownIcon'"
                size="14"
              />
            </div>
          </template>
          <template #cell(created_at)="data">
            {{ __dateTimeFormatter(data.value) }}
          </template>
          <template #cell(bucket.condition.category.name)="data">
            <div class="custom-width">
              {{ data.value }}
            </div>
          </template>
          <template #cell(bucket.name)="data">
            {{ data.value }}
          </template>
          <template #cell(user)="data">
            <div class="d-flex align-items-center">
              <div>
                <div class="font-weight-bolder">
                  {{ `${data.item.user ? data.item.user.first_name : 'N/A'} ${data.item.user && data.item.user.last_name ? data.item.user.last_name : ''}` }}
                </div>
              </div>
            </div>
          </template>
          <template #cell(action)="data">
            <b-dropdown
              no-caret
              toggle-class="text-decoration-none"
              variant="link"
            >
              <template v-slot:button-content>
                <feather-icon
                  class="text-body align-middle mr-25"
                  icon="MoreVerticalIcon"
                  size="12"
                />
              </template>
              <b-dropdown-item
                v-can="'reason-show'"
                @click="handleReopen(data.item)"
              >
                <feather-icon icon="CornerUpLeftIcon" />
                Re Open
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-overlay>
      <div class="mx-2 mb-2">
        <b-row
          cols="12"
        >
          <b-col
            class="d-flex align-items-center justify-content-sm-start"
            md="3"
          >
            <label class="width-75">Per page</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block width-100"
            />
          </b-col>
          <!-- Pagination -->
          <b-col
            class="d-flex align-items-center justify-content-sm-end"
            md="9"
          >
            <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
            <b-pagination
              v-model="page"
              :per-page="perPage"
              :total-rows="(meta.total)? meta.total : 0"
              class="mb-0 mt-1 mt-sm-0"
              first-number
              last-number
              next-class="next-item"
              prev-class="prev-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-card>
</template>
<script>
import {
  BCard,
  BCol,
  BRow,
  BOverlay,
  VBModal,
  BTable,
  BDropdown,
  BDropdownItem,
  VBTooltip,
  BButton,
  BPagination,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import tableMixin from '@core/mixins/tableMixin'

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BButton,
    BPagination,
    vSelect,
  },
  mixins: [tableMixin],
  props: {
    rows: {
      type: Array,
      required: true,
    },
    meta: {
      type: Object,
      default: () => ({}),
    },
    dataLoading: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      fields: [
        {
          key: 'created_at',
          label: 'Sorting Date',
          sortable: false,
        },
        {
          key: 'bucket.condition.category.name',
          label: 'Category Name',
          sortable: true,
          tdClass: 'text-left',
        },
        {
          key: 'bucket.name',
          label: 'Selected Bucket',
          sortable: true,
          tdClass: 'text-left',
        },
        {
          key: 'user',
          label: 'User',
          sortable: true,
          tdClass: 'text-left',
        },
        {
          key: 'action',
          label: 'Action',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
        },
      ],
      page: 1,
      perPage: 20,
      sort: '',
      pageOptions: [10, 20, 50],
    }
  },
  watch: {
    page() {
      this.$emit('pagination-change', { page: this.page, perPage: this.perPage })
    },
    perPage() {
      this.$emit('pagination-change', { page: this.page, perPage: this.perPage })
    },
  },
  methods: {
    addNewSession() {
      this.$emit('newSorting')
    },
    handleReopen(session) {
      this.$emit('reopenSession', {
        date: session.created_at,
        bucket: session.bucket_node_id.toString(),
        bucketName: session.bucket?.name ?? '',
        sortingId: session.sorting_id_string,
      })
    },
  },
}
</script>
